import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { Button } from './ui/button';

const STORAGE_KEY = 'vireo_cookie_consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const choose = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed left-4 bottom-24 sm:bottom-4 z-[55] w-[min(26rem,calc(100vw-2rem))]"
      data-testid="cookie-consent"
    >
      <div className="bg-white border border-slate-200 rounded-2xl shadow-xl p-5">
        <div className="flex items-start gap-3 mb-4">
          <div className="h-9 w-9 rounded-full bg-emerald-50 flex items-center justify-center flex-shrink-0">
            <Cookie className="h-5 w-5 text-emerald-600" />
          </div>
          <div>
            <h3 className="font-bold text-slate-900 text-sm">Votre confidentialité</h3>
            <p className="text-sm text-slate-600 mt-1 leading-relaxed">
              Ce site utilise uniquement des cookies nécessaires à son bon fonctionnement. Aucun
              cookie publicitaire ou de suivi n'est déposé sans votre accord.{' '}
              <Link to="/politique-confidentialite" className="text-emerald-700 font-medium hover:underline">
                En savoir plus
              </Link>
            </p>
          </div>
        </div>
        <div className="flex gap-2">
          <Button
            variant="outline"
            onClick={() => choose('refused')}
            data-testid="cookie-refuse-btn"
            className="flex-1"
          >
            Refuser
          </Button>
          <Button
            onClick={() => choose('accepted')}
            data-testid="cookie-accept-btn"
            className="flex-1 bg-emerald-600 hover:bg-emerald-700"
          >
            Tout accepter
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
